import { PublicKey } from "@solana/web3.js";
import { BN } from "bn.js";
import { SOLANA_OUTBIDS_PROGRAM_PUBLICK_KEY } from "../useOutbid";

export const findBidder = (saleKey: PublicKey, bidderAuthority: PublicKey) => {
  return PublicKey.findProgramAddressSync(
    [Buffer.from("bidder"), saleKey.toBuffer(), bidderAuthority.toBuffer()],
    SOLANA_OUTBIDS_PROGRAM_PUBLICK_KEY
  );
};

export const findBid = (saleKey: PublicKey, bidId: number) => {
  // INFO: From the smart contract:
  // - `bid_id.to_le_bytes()` | Browser doesn't supprt the .toBuffer => Use the BN toArrayLike
  // - `let new_bid_id = sale_state.bids_count;` | The new PDA is derived from the current `bids_count`
  const bidIdBuffer = new BN(bidId).toArrayLike(Buffer, "le", 8);
  return PublicKey.findProgramAddressSync(
    [Buffer.from("bid"), saleKey.toBuffer(), bidIdBuffer],
    SOLANA_OUTBIDS_PROGRAM_PUBLICK_KEY
  );
};

export const findSpecificBidsIncentives = (saleKey: PublicKey) => {
  return PublicKey.findProgramAddressSync(
    [Buffer.from("specific_bids_incentives"), saleKey.toBuffer()],
    SOLANA_OUTBIDS_PROGRAM_PUBLICK_KEY
  );
};
export const findSoldOutBidderIncentives = (saleKey: PublicKey) => {
  return PublicKey.findProgramAddressSync(
    [Buffer.from("sold_out_bidder_incentives"), saleKey.toBuffer()],
    SOLANA_OUTBIDS_PROGRAM_PUBLICK_KEY
  );
};

export const findTransferAuthority = (saleKey: PublicKey) => {
  return PublicKey.findProgramAddressSync(
    [Buffer.from("transfer_authority"), saleKey.toBuffer()],
    SOLANA_OUTBIDS_PROGRAM_PUBLICK_KEY
  );
};

